import React, { useEffect, useState } from 'react';
import { func } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { sanitizeHtml } from '../../util/sanitizeHtml';

import css from './FAQCustomPage.module.css';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { createResourceLocatorString } from "../../util/routes";
import { useRouteConfiguration } from "../../context/routeConfigurationContext";
import { useHistory } from "react-router-dom";

import faqimg from './img/faq.png';
import { Collapse, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchAllFaqs, getFaqsSelector } from '../../ducks/strapi.duck';
const { Search } = Input;
const allItems = [
  {
    key: '1',
    label: 'What is your return policy?',
    children: <p>We offer a 30-day return policy...</p>,
  },
  {
    key: '2',
    label: 'How do I track my order?',
    children: <p>You can track your order through...</p>,
  },
  {
    key: '3',
    label: 'Do you ship internationally?',
    children: <p>Yes, we ship to over 100 countries...</p>,
  },
];


function FAQCustomPage(props) {

  const [searchText, setSearchText] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllFaqs({}));
  }, [dispatch]);
  
  const faqsData = useSelector(getFaqsSelector) || [];

  let filteredItems = faqsData.filter(item =>
    item?.question?.toLowerCase().includes(searchText.toLowerCase()) ||
    item?.answer?.toLowerCase().includes(searchText.toLowerCase()) ||
    (item?.children?.props?.children || '')
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  // Helper function to ensure URLs have protocol
  const ensureProtocol = (url) => {
    if (!url) return url;
    // Check if URL already has a protocol
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Add https:// if missing
    return `https://${url}`;
  };

  filteredItems = filteredItems.map((item, index) => ({
    key: index.toString(),
    label: item?.question || item?.attributes?.question,
    children: (
      <div className={css.faqAnswer}>
        <ReactMarkdown 
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]} // This allows HTML tags like <u>, <mark>, etc.
          components={{
            // Custom rendering for links to fix protocol issue and open in new tab
            a: ({node, href, ...props}) => {
              const { children } = props;

              const fixedHref = ensureProtocol(Array.isArray(children) ? children.join('') : children);
              
              return <a {...props} href={fixedHref} target="_blank" rel="noopener noreferrer" />;
            },
            // Custom rendering for images
            img: ({node, ...props}) => <img {...props} className={css.faqImage} alt={props.alt || ''} />,
          }}
        >
          {sanitizeHtml(item?.answer || item?.attributes?.answer || '')}
        </ReactMarkdown>
      </div>
    ),
  }));


  const { onUpdateProfile, params, scrollingDisabled } = props;


  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const redirectToSignupPage = () => {
    history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}));
  };

  return (
    <Page title={'FAQ'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        sideNavClassName={css.navigation}
        topbar={
          <TopbarContainer
            mobileRootClassName={css.mobileTopbar}
            desktopClassName={css.desktopTopbar}
          />
        }
        footer={<FooterContainer />}
      >
        <div className={css.faqContainer}>
          <div className={css.faqCircle}></div>
          <div className={css.faqBlock}>
            <img src={faqimg} alt='FAQ' className={css.faqImg} />
            <h1>Frequently Asked <span>Questions</span></h1>
            <h4>Everything you need to know.</h4>
            <Input
              placeholder="Search FAQ"
              value={searchText}
              size='large'
              suffix={<SearchOutlined />}
              className={css.faqSearch}
              onChange={e => setSearchText(e.target.value)}
              autoFocus
            />
            <div className={css.faqList}>
            <Collapse accordion items={filteredItems} ghost bordered={false} />
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
}
FAQCustomPage.propTypes = {
  // onCreateCredentials: func.isRequired,
  onUpdateProfile: func.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  // onCreateCredentials: data => dispatch(createCredentials(data)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

export default FAQCustomPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(FAQCustomPage);